<template lang="html">
  <div class="predict-categories text-center">
    <div class="tab-content predict-categories-content">
      <div :class="`tab-pane predict-categories-tab ${ predictStep === 'predict' ? 'active' : ''}`">

        <!-- Alert message -->
        <div class="alert alert-info mb-3 mx-auto">
          <div class="font-weight-bold">IMPORTANTE</div>
          <div>Nunca vamos a contactarte para pedirte códigos ni datos personales.</div>
        </div>
        <h5 class="mb-3" style="font-size: 18px;">Indicanos qué producto querés vender:</h5>
        <input
          class="form-control"
          placeholder="Ej: Ford Fiesta / Samsung S20"
          type="text"
          v-model="predictQuery"
          @input="emptyPrediction = false"
          @keypress.enter="getPredictions">
        <p v-if="emptyPrediction" class="mb-0 text-left small text-danger">Este campo es obligatorio</p>
        <SquaredButton
          class="d-block mx-auto my-3"
          @click="getPredictions"
          styleType="primary"
          label="Continuar" />
        <SquaredButton
          class="d-block mx-auto"
          @click="handleManualSelect(false)"
          styleType="link"
          label="Elegir manualmente" />
      </div>
      <div :class="`tab-pane predict-categories-tab ${ predictStep === 'suggestions' ? 'active' : ''}`">
        <h6 class="mb-3">Elegí la categoría que se ajuste al producto:</h6>
        <CategoryGroupSelect
          class="predict-categories-combo"
          :items="categories"
          @selected="handleSelectCategory" />
        <SquaredButton
          class="d-inline-block my-3"
          @click="handleGoBack"
          styleType="link"
          label="Anterior" />
        <SquaredButton
          class="d-inline-block my-3"
          @click="handleNext"
          :disabled="!selectedCategory"
          styleType="primary"
          label="Seleccionar" />
        <SquaredButton
          @click="handleManualSelect(true)"
          styleType="link"
          label="Elegir manualmente" />
      </div>
      <div :class="`tab-pane predict-categories-tab ${ predictStep === 'empty' ? 'active' : ''}`">
        <div class="text-danger my-4">
          No encontramos categorías sugeridas para "{{predictQuery}}". Elegí la categoría manualmente.
        </div>
        <SquaredButton
          class="d-block mx-auto my-3"
          @click="handleGoBack"
          styleType="primary"
          label="Reintentar" />
        <SquaredButton
          class="d-block mx-auto"
          @click="handleManualSelect(false)"
          styleType="link"
          label="Elegir manualmente" />
      </div>
    </div>
    <Loading :active="isFetching" />
  </div>
</template>

<script>
  import store from '@/store'
  import {urls, api} from '@/api'

  export default {
    data: () => ({
      predictStep: 'predict',
      predictQuery: '',
      categories: [],
      selectedCategory: '',
      isFetching: false,
      emptyPrediction: false
    }),

    methods: {
      getPredictions () {
        if (!this.predictQuery) {
          this.emptyPrediction = true
          return
        } else
          this.emptyPrediction = false
        this.isFetching = true
        api.get(`${urls.categoriesPredict}?q=${this.predictQuery}`)
          .then(({ data }) => {
            if (data.data && data.data.length > 0) {
              this.categories = data.data
              this.predictStep = 'suggestions'
            } else {
              this.predictStep = 'empty'
            }
          })
          .catch(err => { console.warn('Error fetching category suggestions: ', err) })
          .finally(() => { this.isFetching = false })
      },

      handleSelectCategory (e) {
        const params = { category_id: e }
        this.isFetching = true

        api.get(urls.sellCategories, { params })
          .then(({data}) => { this.selectedCategory = data.data[0] })
          .catch(err => { console.warn('Error fetching category: ', err) })
          .finally(() => { this.isFetching = false })
      },

      handleGoBack () {
        this.predictStep = 'predict'
        this.categories = []
        this.selectedCategory = ''
      },

      handleNext () {
        this.$emit('selected', this.selectedCategory)
        this.resetPredictions()
        this.pushToDataLayer('Sell page', 'Category predicted')
      },

      handleManualSelect (results) {
        this.$emit('selected', 'manual')
        this.resetPredictions()
        if (results) {
          this.pushToDataLayer('Sell page', 'Category manual with results')
        } else {
          this.pushToDataLayer('Sell page', 'Category manual with no results')
        }
      },

      resetPredictions () {
        this.predictQuery = ''
        this.categories = []
        this.selectedCategory = ''
        this.predictStep = 'predict'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/breakpoints';

  .predict-categories {
    min-height: 40vh;

    &-content {
      margin-top: 0.25rem;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      max-width: 400px;
    }

    &-tab {

    }

    &-icon {
      height: 42px;
      margin: auto;
      display: block;
      cursor: pointer;
    }

    &-combo {
      & .list-group, & > .form-group > select {
        height: fit-content;
      }
    }

    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      &-content {
        max-width: 100%;
      }

      &-combo {
        & .list-group, & > .form-group > select {
          text-align: left;
          font-size: 16px;
          min-height: 150px;
        }

        & .list-group li {
          padding: 8px !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/PredictCategories.vue